import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Heart, Mail, Lock, Eye, EyeOff } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';
import { useAuth, nextRoute } from '../context/AuthContext';
import { GoogleButton } from '../components/GoogleButton';

export default function Login() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast({ title: 'Isi email & password dulu ya', variant: 'destructive' }); return; }
    setBusy(true);
    try {
      const user = await login(email, password);
      toast({ title: 'Selamat datang kembali!', description: 'Yuk lanjut persiapan pernikahanmu.' });
      navigate(nextRoute(user));
    } catch (err) {
      toast({ title: 'Login gagal', description: err?.response?.data?.detail || 'Coba lagi', variant: 'destructive' });
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-cream-100 flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <div className="w-10 h-10 rounded-full bg-terracotta-500 flex items-center justify-center">
            <Heart className="w-5 h-5 text-white" fill="white" />
          </div>
          <div className="font-serif text-xl text-sage-700">Naik Pelaminan</div>
        </Link>

        <div className="bg-white rounded-3xl p-8 shadow-sm border border-cream-200">
          <h1 className="font-serif text-3xl text-sage-700 mb-2">Selamat datang kembali</h1>
          <p className="text-sage-500 text-sm mb-6">Masuk untuk lanjut persiapan pernikahan.</p>

          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label className="text-sage-600 text-sm">Email</Label>
              <div className="relative mt-1.5">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-sage-400" />
                <Input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="kamu@email.com" className="pl-10 h-11 bg-cream-50 border-cream-200 rounded-xl" />
              </div>
            </div>
            <div>
              <Label className="text-sage-600 text-sm">Password</Label>
              <div className="relative mt-1.5">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-sage-400" />
                <Input data-testid="login-password-input" type={show ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="pl-10 pr-10 h-11 bg-cream-50 border-cream-200 rounded-xl" />
                <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-sage-400">
                  {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            <Button data-testid="login-submit-button" type="submit" disabled={busy} className="w-full h-11 bg-terracotta-500 hover:bg-terracotta-600 text-white rounded-full">{busy ? 'Memproses...' : 'Masuk'}</Button>
          </form>

          <GoogleButton label="Masuk dengan Google" />

          <p className="mt-6 text-center text-sm text-sage-500">
            Belum punya akun? <Link to="/register" className="text-terracotta-500 font-medium">Daftar sekarang</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
